export const GET_CONTACTS = "GET_CONTACTS";
export const RESET_CONTACTS = "RESET_CONTACTS";
export const SET_CONTACTS_REQUEST_STATUS = "SET_CONTACTS_REQUEST_STATUS";

export interface Contact {
  id: number;
  name: string;
  email: string;
  phone: string;
  status: number;
  createdAt: string;
  updatedAt: string;
  organizationId: number;
  propertyId: number;
  nextActionDate: string;
}
